var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScrollDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 37,
    viewBox: "0 0 16 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_87)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.44 22.4L14.75 20.49C15.09 20.29 15.31 19.92 15.31 19.53V6.42C15.31 6.02 15.1 5.66 14.75 5.46L8.59 1.9C8.25 1.7 7.82 1.7 7.48 1.9L1.31 5.46C0.97 5.66 0.75 6.03 0.75 6.42V19.52C0.75 19.92 0.96 20.28 1.31 20.48L4.62 22.39",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03003 6.90997V11.13",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03003 21.38V34.03",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.31 30.59L8.03 34.87L3.75 30.59",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_87"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 37,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollDown);
export default __webpack_public_path__ + "static/media/scroll_down.846b290d3e632f285a8787960153ad47.svg";
export { ForwardRef as ReactComponent };